import React, { useContext, useEffect } from "react";
import { AppContext } from "../../../Context";
import { GetCodedValueAndAlias, getMapView } from "../../../utils/arcgisUtils";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { AppConfig } from "../../../AppConfig";
import { formatDate } from "../../../utils/helpers";
import type Relationship from "@arcgis/core/layers/support/Relationship";
import type Graphic from "@arcgis/core/Graphic";

interface RelatedObjectProps {
    feature: Graphic;
    relationship: Relationship;
    isEditing: boolean;
}

const RelatedObject: React.FC<RelatedObjectProps> = ({ feature, relationship, isEditing }) => {
    const [featureTitle, setFeatureTitle] = React.useState<string>("Henter...");
    const appContext = useContext(AppContext);

    const getFeatureTitle = async () => {
        const mapview = getMapView();
        if (!mapview?.map) return;
        let allLayers = mapview.map.allLayers.toArray();
        allLayers = allLayers.concat(mapview.map.allTables.toArray());
        const layer = allLayers.find(
            (layer) => (layer as FeatureLayer).layerId === relationship.relatedTableId
        ) as FeatureLayer;
        if (!layer) {
            return;
        }
        if (!layer.loaded) {
            await layer.load();
        }

        const layerConfig = AppConfig.Layers.find((config) => config.Name === layer.id);

        const titlefield = layerConfig?.TitleField;
        if (titlefield) {
            if (titlefield === "malt_dato") {
                const dateValue = feature.attributes[titlefield];
                if (dateValue) {
                    const formattedDate = formatDate(dateValue);
                    setFeatureTitle(formattedDate);
                    return;
                }
            }
            const codedValueTitle = GetCodedValueAndAlias(layer, titlefield, feature.attributes[titlefield])[1];
            if (codedValueTitle) {
                setFeatureTitle(codedValueTitle.toString());
                return;
            }
        }

        let title =
            feature.attributes.navn ||
            feature.attributes.sjomerke_nr ||
            feature.attributes.gis_obj_id ||
            feature.attributes.nav_id ||
            feature.attributes.sektor_nr ||
            feature.attributes.objectid ||
            "Ukjent";

        setFeatureTitle(title);
    };

    const selectFeature = async () => {
        const mapview = getMapView();
        if (!mapview?.map) return;
        let allLayers = mapview.map.allLayers.toArray();
        allLayers = allLayers.concat(mapview.map.allTables.toArray());
        const layer = allLayers.find(
            (layer) => (layer as FeatureLayer).layerId === relationship.relatedTableId
        ) as FeatureLayer;
        if (!layer) {
            return;
        }
        if (!layer.loaded) {
            await layer.load();
        }

        feature.layer = layer;
        appContext?.selectedFeature.set(feature);
    };

    const showFeature = async () => {
        const mapview = getMapView();
        if (!mapview?.map) return;
        let allLayers = mapview.map.allLayers.toArray();
        allLayers = allLayers.concat(mapview.map.allTables.toArray());
        const layer = allLayers.find(
            (layer) => (layer as FeatureLayer).layerId === relationship.relatedTableId
        ) as FeatureLayer;
        if (!layer) {
            return;
        }
        if (!layer.loaded) {
            await layer.load();
        }

        feature.layer = layer;
        appContext?.shownFeature.set(feature);
    };

    useEffect(() => {
        getFeatureTitle();
    }, []);

    return (
        <div className="flex-row space-between">
            <h3>{featureTitle}</h3>
            {/* <p>ID: {feature.attributes.id}</p> */}
            {/* Add more details as needed */}
            {isEditing && (
                <button className="empty-button" onClick={selectFeature}>
                    Åpne
                </button>
            )}
            {!isEditing && (
                <button className="empty-button" onClick={showFeature}>
                    Vis
                </button>
            )}
        </div>
    );
};

export default RelatedObject;
